import React, { PureComponent } from "react";

import Loader from "components/Loader/Loader.js";
import { Metric, Error } from "components/Utils/Utils.js";
import Heading from "components/Elements/Heading";

class ChurnPayingSubs extends PureComponent {
  render() {
    const { loading, data, url } = this.props;

    if (data.data.hasData === false) {
      return <Error minHeight={360} />;
    }
    if (loading) {
      return <Loader minHeight={200} col={"col-12 col-md-6"} />;
    }

    const isTotalMetrics = url.includes("metrics=total_loss");

    return (
      <div className="row mt-2">
        {data.data.total_loss_ftp && isTotalMetrics && (
          <div className="col mb-3 mb-sm-0">
            <Heading size={6} className={"mb-1"}>
              Total Loss: Free Trial + Paid
            </Heading>

            <div className="d-flex">
              <Metric {...data.data.total_loss_ftp} size={"lg"} format={"%"} />
            </div>

            <div className="d-flex justify-content-left align-items-center">
              <h6 className="mb-0 mr-2">Monthly</h6>
              <Metric
                {...data.data.total_loss_ftp_monthly}
                size={"xs"}
                format={"%"}
              />
            </div>
            <div className="d-flex justify-content-left align-items-center">
              <h6 className="mb-0 mr-2">Annual</h6>
              <Metric
                {...data.data.total_loss_ftp_annual}
                size={"xs"}
                format={"%"}
              />
            </div>
          </div>
        )}

        {data.data.total_loss_paying && isTotalMetrics && (
          <div className="col mb-3 mb-sm-0">
            <Heading size={6} className={"mb-1"}>
              Total Loss: Paying Only
            </Heading>

            <div className="d-flex">
              <Metric
                {...data.data.total_loss_paying}
                size={"lg"}
                format={"%"}
              />
            </div>

            <div className="d-flex justify-content-left align-items-center">
              <h6 className="mb-0 mr-2">Monthly</h6>
              <Metric
                {...data.data.total_loss_paying_monthly}
                size={"xs"}
                format={"%"}
              />
            </div>
            <div className="d-flex justify-content-left align-items-center">
              <h6 className="mb-0 mr-2">Annual</h6>
              <Metric
                {...data.data.total_loss_paying_annual}
                size={"xs"}
                format={"%"}
              />
            </div>
          </div>
        )}

        {data.data.subs_up_for_renewal && !isTotalMetrics && (
          <div className="col mb-3 mb-sm-0">
            <Heading size={6} className={"mb-1"}>
              Subs Up For Renewal (Next 7 Days)
            </Heading>

            <div className="d-flex">
              <Metric {...data.data.subs_up_for_renewal} size={"lg"} />
            </div>

            <div className="d-flex justify-content-left align-items-center">
              <h6 className="mb-0 mr-2">Monthly</h6>
              <Metric {...data.data.subs_up_for_renewal_monthly} size={"xs"} />
            </div>
            <div className="d-flex justify-content-left align-items-center">
              <h6 className="mb-0 mr-2">Annual</h6>
              <Metric {...data.data.subs_up_for_renewal_annual} size={"xs"} />
            </div>
          </div>
        )}

        {data.data.predicted_conversions && !isTotalMetrics && (
          <div className="col mb-3 mb-sm-0">
            <Heading size={6} className={"mb-1"}>
              Predicted Conversion (Next 7 Days)
            </Heading>

            <div className="d-flex">
              <Metric {...data.data.predicted_conversions} size={"lg"} />
            </div>
            <div className="d-flex justify-content-left align-items-center">
              <h6 className="mb-0 mr-2">Monthly</h6>
              <Metric
                {...data.data.predicted_conversions_monthly}
                size={"xs"}
              />
            </div>
            <div className="d-flex justify-content-left align-items-center">
              <h6 className="mb-0 mr-2">Annual</h6>
              <Metric {...data.data.predicted_conversions_annual} size={"xs"} />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ChurnPayingSubs;
